import { observable } from "mobx";
import AccountingDocumentCandidateApprovalType from "./accountingDocumentCandidateApprovalType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentCandidateApprovalResponse {
  @observable
  approvalType!: AccountingDocumentCandidateApprovalType;
}
